import { Component, OnInit } from '@angular/core';
import { Utils } from './../../../common/utils';
import { MessageService, ConfirmationService, SelectItem } from 'primeng/api';
import { UntypedFormGroup} from '@angular/forms';
import { GenericService } from 'src/app/services/generic/generic.service';
import { FechasService } from 'src/app/services/fechas/fechas';

@Component({
  selector: 'app-articulos-list',
  templateUrl: './articulos-list.component.html',
  styleUrls: ['./articulos-list.component.css']
})
export class ArticulosListComponent implements OnInit {

  public cols = [
    { header: 'Opciones', field: 'opciones'},
    { header: 'Foto', field: 'foto', width:'60px'},
    { header: 'Proveedor', field: 'proveedor_abv', width: '100px', tipo: 'texto'},
    { header: 'Nombre artículo', field: 'nombre'},
    { header: 'Descripción', field: 'descripcion'},
    { header: 'Maceta', field: 'maceta', width:'120px'},
    { header: 'Color', field: 'color', width: '190px'},
    { header: 'Tamaño', field: 'tamano', width:'140px'},
    { header: 'Unidades/piso', field: 'unidades_piso', width:'80px'},
    { header: 'Unidades/cc', field: 'unidades_cc', width:'80px'},
    { header: 'Precio neto vivero', field: 'precio_neto_vivero', width:'80px'},
    { header: 'Precio etiqueta artículo', field: 'precio_etiqueta_articulo', width:'80px'},
    { header: 'Unidades/caja', field: 'unidades_caja', width:'80px'},
    { header: 'Pisos/cc', field: 'pisos_cc' , width:'80px' },
    { header: 'Peso (Kg)', field: 'peso', width:'80px'},
    { header: 'EAN vivero', field: 'ean_vivero' , width:'120px' },
    { header: 'Precio comisión artículo', field: 'precio_comision_articulo', width:'80px'},
    { header: 'Precio comisión carro', field: 'precio_comision_carro', width:'80px'},
    { header: 'Código Genérico', field: 'codigo_generico', width:'120px'},
    { header: 'Código Dehner', field: 'codigo_dehner', width:'120px'},
    { header: 'Código Schmid', field: 'codigo_schmid', width:'120px'},
    { header: 'Código Transportgemeinschaft', field: 'codigo_migros', width:'120px'},
    { header: 'Código Irsslinger', field: 'codigo_irsslinger', width:'120px'},
    { header: 'Código Blume2000', field: 'codigo_blume2000', width:'120px'},
    { header: 'Código Landgard', field: 'codigo_landgard', width:'120px'},
    { header: 'Cantidad cargada', field: 'cantidad_cargada', width:'80px'},
    { header: 'Cantidad reservada', field: 'cantidad_reservada', width:'80px'},
    { header: 'Fecha creación', field: 'fecha_creacion', width:'100px' , tipo:'fecha'},
    { header: 'Activo', field: 'activo', width:'80px'}
  ];

  public es = Utils.es;
  public date2: Date;
  public expression = false;
  public title = "Artículos";
  public control: any = [];
  public TransporteData: any = [];
  public displayDialog = false;
  public editControl: any = [];
  public mostrar = false;
  public display: boolean = false;
  public createControlForm: UntypedFormGroup;
  public myMonth = "";
  public database = "warticulos";
  public database_origen = "articulos";

  public selectedOpciones: string = "";
  public oldValue: string = "";
  public columnasVisibles: boolean = false;
  public showInfo: boolean = true;
  public showDuplicate: boolean = true;
  public opciones: SelectItem[];

  public selectedColumns: any[];
  public anchoTabla = "1500px";
  public showTables: boolean = true;
  public listarTodos: boolean = true;
  public mostrarInformes: boolean = true;
  public displayMultiple: any;

  private _fechaService: FechasService;

  constructor(
    private genericService: GenericService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) {

    this.showCols();

  }

  ngOnInit(): void {

    this.iniciar();

  }

  /**
   * Funcion inicial para mostrar los datos en la lista
   */
  iniciar() {
    this.mostrar = false;
    this.genericService.getListSimple( this.database, 'fecha_creacion_for_list').toPromise().then((data: any) => {

      //TODO Revisar condicion
      this.control = data.productos;
      this.control.forEach(p => {

        if(p.precio_neto_vivero != null && p.precio_neto_vivero.length > 0){
          p.precio_neto_vivero = parseFloat(p.precio_neto_vivero);
        }
      })


      this.mostarTabla();

    }).catch(error => {
      console.log("Error", error);
    });
  }

  listarCampos() {

    if (this.showTables) {
      this.showTables = false;
      this.columnasTotales();


    } else {
      this.showTables = true;
      this.columnasSimples();

    }
  }


  showCols(){
      this.columnasVisibles = false;
      this.anchoTabla = "1500px";
      this.selectedColumns = this.cols;

  }


  mostarTabla() {
    this.mostrar = true;
  }

  columnasSimples() {
    this.columnasVisibles = false;
    this.anchoTabla = "1500px";
    this.selectedColumns = this.cols;
  }
  columnasTotales() {
    this.columnasVisibles = false;
    this.anchoTabla = "4000px";
    this.selectedColumns = this.cols;
  }

  delete(id) {
    this.confirmationService.confirm({
      header: 'Confirmación',
      acceptLabel: 'Acceptar',
      rejectLabel: 'Cancelar',
      message: 'Quieres eliminar este registro?',
      accept: () => {

        this.genericService.delete( id, this.database_origen ).subscribe(data => {
          // console.log("Ha ido bien",data);
          this.iniciar();
        }, error => {
          console.error("error ", error);
        });
      }
    });

  }


  cerrar() {
    this.display = false;

    this.expression = false;
  }

  closeWindow(event) {
    this.cerrar();
  }




  duplicate(transporte) {
    let newId = "";
    this.genericService.clone(transporte.id, this.database_origen).toPromise().then((data:any) => {

      newId = data.id;

      this.messageService.add({ severity: 'success', summary: `Registro ${this.database_origen}`, detail: `Registro ${this.database_origen} Duplicado` });
      this.iniciar();
    }).catch(error => {
      this.messageService.add({ severity: 'error', summary: `Registro ${this.database_origen}`, detail: `Error en registro ${this.database_origen}` });
      console.log("error", error);
    });

  }

  public mydt: any;
  closeWindowMultpile(event) {
    this.consultar();
  }

  cambios(dt) {

    this.mydt = dt;

  }
  consultar() {

    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple = true;
    }
    if (this.mydt == null || this.mydt == undefined || this.mydt.length == 0) {

    } else if (this.mydt.filteredValue == null || this.mydt == undefined) {

    } else {

    }
  }

  changeValueRevision(event){
    console.log("function value revision",event);

  }
  changeValue(event){
    console.log("function value",event);

  }

  tableRowTransform($row: any){}

  tableCellTransform($column: any, $value: any) {
    if($column == 'activo') {
      if ($value == 1) {
        return 'Activo'
      } else{
        return 'No activo'
      }
    }

    return $value;
  }

  exportToCSV() {

    const headers = [
      'Nombre Articulo',
      'Descripcion',
      'Maceta',
      'Tamaño',
      'Unidades/Piso',
      'Unidades/cc',
      'Precio Neto',
      'Fecha Creacion',
      'Activo'
    ]

    const cols = [
      'nombre',
      'descripcion',
      'maceta',
      'tamano',
      'unidades_piso',
      'unidades_cc',
      'precio_neto_vivero',
      'fecha_creacion',
      'activo'
    ]

    const charset = 'windows-1252';
    let csv = `data:text/csv;charset=${charset},\ufeff ${headers.join(';')}\n`;

    this.control.forEach((item:any) => {
      cols.forEach(c => {
        let data = item[c];

        if(data) {
          try {
            if (c === 'activo') {
              data = data == 1 ? 'Activo' : 'No activo';
            }

            if (typeof data === 'number') {
              data = data.toString();
            } else {
              data = data.replace('#','');
            }
          } catch (e) {
            data = '';
            console.log('Error to export CSV articulos', e);
          }
        } else {
          data = '';
        }

        csv += `"${data.replace(/"/g,'\\"')}";`;
      })
      csv = csv.slice(0,-1) + '\n';
    });

    const link = document.getElementById('csvLink') as HTMLAnchorElement;
    link.download = `listado_articulos_${new Date().toDateString()}.csv`;
    link.href = encodeURI(csv);
    link.click();
  }

}
